import React from 'react'
import logo from '../../assets/images/logo.svg';


function logoFunc() {
    return (
        <img src={logo} className="App-logo" alt="logo" />
    )
}

export default logoFunc
